export const SET_AUTH_DATA = 'SET_AUTH_DATA';

export const LOGOUT_USER = 'LOGOUT_USER';
